import "@styles/base/pages/page-misc.scss";

import { Link, useNavigate } from "react-router-dom";

import Breadcrumbs from "@components/ui-components/breadcrumbs";
import { Button } from "reactstrap";
import ImageWrapper from "@components/ui-components/image-wrapper";
import { handleToken } from "@helpers/utils";
import size from "lodash/size";
import themeConfig from "@configs/theme-config";
import { useEffect } from "react";

const NotAuthorized = (props) => {
    const { showBtn = true, breadcrumbItems = [], internal = false } = props;
    const navigate = useNavigate();
    // ** Hooks
    useEffect(() => {
        if (!handleToken()) {
            navigate("/");
        }
    }, []);

    const { app:{ logo } } = themeConfig;

    // ** Vars
    return (
        <>
            {size(breadcrumbItems) ? <Breadcrumbs items={breadcrumbItems} /> : null}
            <div className="misc-wrapper">
                {!internal && (
                    <span className="brand-logo">
                        <ImageWrapper
                            src={logo}
                            id="brand-logo"
                            alt="logo"/>
                    </span>
                )}
                <div className="misc-inner p-2 p-sm-3">
                    <div className="w-100 text-center">
                        <h2 className="mb-75">You are not authorized! 🔐</h2>
                        <ImageWrapper
                            className="img-fluid"
                            id="not-authorized"
                            src={"common/not-authorized.png"}
                            alt="Not authorized page"/>
                        <br />
                        {showBtn ? (
                            <Button
                                tag={Link}
                                to="/"
                                color="primary"
                                className="btn-sm-block mb-1">
                                Back to home
                            </Button>
                        ) : (
                            <h5>
                                You will need to contact your account manager for permissions
                            </h5>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
export default NotAuthorized;
